import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { UserContentGroupList } from '@core/entities';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  getContentGroups(queryParams?: FilterQuery): Observable<UserContentGroupList> {
    return this._http.get<any>(`${this._apiUrl}/getOwnerGroups`, { params: queryParams });
  }
}
